import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, BookOpen, FileText, MessageSquare, Users, Star, ClipboardList, LogOut, ArrowLeft, Award, Settings } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/admin", label: "Genel Bakış", icon: LayoutDashboard, end: true },
  { to: "/admin/egitimler", label: "Eğitimler", icon: BookOpen },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/yorumlar", label: "Yorumlar", icon: Star },
  { to: "/admin/iletisim", label: "İletişim", icon: MessageSquare },
  { to: "/admin/kayit-formlari", label: "Kayıt Formları", icon: ClipboardList },
  { to: "/admin/ogrenciler", label: "Öğrenciler", icon: Users },
  { to: "/admin/sertifikalar", label: "Sertifikalar", icon: Award },
  { to: "/admin/ayarlar", label: "Ayarlar", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex">
      <aside data-testid="admin-sidebar" className="w-64 shrink-0 border-r border-white/10 bg-black min-h-screen sticky top-0 hidden md:block">
        <div className="p-6 border-b border-white/10">
          <div className="font-display text-xl">ZB Yönetim</div>
          <div className="text-[10px] uppercase tracking-[0.32em] text-gold mt-1">Admin Panel</div>
        </div>
        <nav className="p-4 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                  isActive ? "bg-gold/10 text-gold border-l-2 border-gold" : "text-white/70 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <l.icon className="w-4 h-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 mt-auto space-y-2 absolute bottom-0 left-0 right-0">
          <div className="px-4 pb-3">
            <div className="text-xs text-white/50">Giriş yapan</div>
            <div className="text-sm text-white truncate">{user?.email}</div>
          </div>
          <button onClick={() => navigate("/")} className="w-full flex items-center gap-2 text-sm text-white/60 hover:text-gold px-4 py-2">
            <ArrowLeft className="w-4 h-4" /> Siteye Dön
          </button>
          <button onClick={handleLogout} className="w-full flex items-center gap-2 text-sm text-white/60 hover:text-gold px-4 py-2">
            <LogOut className="w-4 h-4" /> Çıkış
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        {/* Mobile top */}
        <div className="md:hidden border-b border-white/10 p-4 flex items-center justify-between">
          <div className="font-display text-lg">ZB Yönetim</div>
          <button onClick={handleLogout} className="text-white/60 hover:text-gold text-sm">Çıkış</button>
        </div>
        <div className="md:hidden overflow-x-auto border-b border-white/10">
          <div className="flex gap-2 p-3 min-w-max">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `text-xs uppercase tracking-widest px-3 py-2 border ${isActive ? "border-gold text-gold" : "border-white/10 text-white/60"}`}>
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
        <main className="p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
